import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateTeacher as apiUpdate } from "../../api/apiTeachers";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useUpdateTeacher() {
    const navigate = useNavigate(); const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: editTeacher, isPending: isUpdate, error } = useMutation({
        mutationFn: ({ req, id }) => apiUpdate(req, id),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["teachers"] }); navigate('/teachers'); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); },
    });
    return { editTeacher, isUpdate, error };
}
